"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var functionalStepperTheme = function functionalStepperTheme(theme) {
  return {
    appearance: {
      primary: {
        color: '',
        defaultBackgroundColor: 'transparent',
        activeBackgroundColor: theme.color.monochrome6["default"],
        activeStepColor: theme.color.monochrome1["default"],
        stepBorder: "".concat(theme.border.width[1], " ").concat(theme.border.style[1]),
        stepBorderColor: theme.color.monochrome6["default"],
        iconAppearance: 'primary',
        link: {
          appearance: 'primary',
          inverse: false
        },
        controlLink: {
          appearance: 'secondary',
          inverse: false
        },
        hideControlsHeading: {
          appearance: 'primary',
          inverse: false
        },
        controlHeading: {
          appearance: 'primary',
          inverse: false
        },
        inverse: {
          color: theme.inverseColor.monochrome6["default"],
          defaultBackgroundColor: 'transparent',
          activeBackgroundColor: theme.color.monochrome1["default"],
          activeStepColor: theme.color.monochrome6["default"],
          stepBorder: "".concat(theme.border.width[1], " ").concat(theme.border.style[1]),
          stepBorderColor: theme.inverseColor.monochrome6["default"],
          iconAppearance: 'primary',
          link: {
            appearance: 'primary',
            inverse: false
          },
          controlLink: {
            appearance: 'secondary',
            inverse: false
          },
          hideControlsHeading: {
            appearance: 'primary',
            inverse: false
          },
          controlHeading: {
            appearance: 'primary',
            inverse: true
          }
        }
      }
    },
    state: {
      success: {
        backgroundColor: theme.color.success["default"],
        stepBorderColor: theme.color.success["default"],
        textColor: theme.color.success["default"],
        inverse: {
          backgroundColor: theme.inverseColor.success["default"],
          stepBorderColor: theme.inverseColor.success["default"],
          textColor: theme.inverseColor.success["default"]
        }
      },
      error: {
        backgroundColor: theme.color.error["default"],
        stepBorderColor: theme.color.error["default"],
        textColor: theme.color.error["default"],
        inverse: {
          backgroundColor: theme.inverseColor.error["default"],
          stepBorderColor: theme.inverseColor.error["default"],
          textColor: theme.inverseColor.error["default"]
        }
      },
      info: {
        backgroundColor: theme.color.info["default"],
        stepBorderColor: theme.color.info["default"],
        textColor: theme.color.info["default"],
        inverse: {
          backgroundColor: theme.inverseColor.info["default"],
          stepBorderColor: theme.inverseColor.info["default"],
          textColor: theme.inverseColor.info["default"]
        }
      },
      warn: {
        backgroundColor: theme.color.warn["default"],
        stepBorderColor: theme.color.warn["default"],
        textColor: theme.color.warn["default"],
        inverse: {
          backgroundColor: theme.inverseColor.warn["default"],
          stepBorderColor: theme.inverseColor.warn["default"],
          textColor: theme.inverseColor.warn["default"]
        }
      }
    }
  };
};

var _default = functionalStepperTheme;
exports["default"] = _default;
//# sourceMappingURL=FunctionalStepper.theme.js.map